import Message from 'src/view/shared/message'
//import { getHistory } from 'src/modules/store'
import { i18n, i18nExists } from 'src/i18n'
import { range } from 'src/modules/shared/functional/arrayFunctions'
import { ApiError, ApiResultValidationError, UserError, AppError } from 'src/modules/shared/error/AppError'

const DEFAULT_ERROR_MESSAGE = i18n('errors.defaultErrorMessage')

const ERROR_CODE_APPLICATION_ERROR = 1001

function selectErrorKeyOrMessage(error) {
  if (error && error.response && error.response.data) {
    const data = error.response.data

    if (data.errorCode) {
      return data.errorCode
    } else if (data.error && data.error.message) {
      return data.error.message
    } else if (data.message) {
      return data.message
    } else if (data.errors) {
      return data.errors.join(', ')
    }

    return JSON.stringify(data)
  }

  return error.message || DEFAULT_ERROR_MESSAGE
}

function selectErrorMessage(error) {
  const key = selectErrorKeyOrMessage(error)

  if (i18nExists(key)) {
    return i18n(key)
  }
  const extendedKey = `errors.api.${key}`
  if (i18nExists(extendedKey)) {
    return i18n(extendedKey)
  }

  return key
}

function selectErrorCode(error) {
  if (error && error.response && error.response.status) {
    return error.response.status
  } else if (error && error.code) {
    return error.code
  } else {
    return ERROR_CODE_APPLICATION_ERROR
  }
}

export default class Errors {
  static handle(error) {
    if (process.env.NODE_ENV !== 'test') {
      console.error(selectErrorMessage(error))
      console.error(error)
    }

    if (error instanceof UserError) {
      Message.error(error.getLocalisedMessage())
      return
    } else if (error instanceof AppError) {
      Message.error(error.getLocalisedMessage())
      return
    } else if (error instanceof ApiError) {
      Message.error(error.getLocalisedMessage())
      return
    } else if (error instanceof ApiResultValidationError) {
      Message.error(error.message)
      return
    }

    const errorCode = selectErrorCode(error)

    if (errorCode === 401) {
      Message.error(i18n('errors.401'))
      return
    }

    if (errorCode === 403) {
      //getHistory().push('/403')
      Message.error(i18n('errors.403'))
      return
    }

    if ([400, 429].includes(errorCode)) {
      Message.error(selectErrorMessage(error))
      return
    }

    const statuses500 = range(100, 500)
    if (statuses500.includes(errorCode)) {
      Message.error(selectErrorMessage(error))
      return
    }

    if (errorCode === ERROR_CODE_APPLICATION_ERROR) {
      //getHistory().push('/admin-v2/ApplicationError')
      return
    }

    Message.error(selectErrorMessage(error))
  }

  static errorCode(error) {
    return selectErrorCode(error)
  }

  static selectMessage(error) {
    return selectErrorMessage(error)
  }

  static showMessage(error) {
    Message.error(selectErrorMessage(error))
  }
}
